import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import FeatherIcon from "feather-icons-react";
import {
  faBlenderPhone,
  faHome,
  faBell,
  faEnvelope,
  faExpand,
  faGear,
  faFile,
  faArrowRight,
  faGears,
  faNetworkWired,
  faCubes,
  faCartShopping,
  faFileInvoice,
  faSackDollar,
  faNoteSticky,
  faListCheck,
  faCreditCard,
  faShoppingCart,
  faWarehouse,
  faLocationDot,
  faPersonWalking,
  faRunning,
  faMoneyBill,
  faChartLine,
  faPersonBiking,
  faIndent,
} from "@fortawesome/free-solid-svg-icons";
import { Popover, Button } from "antd";
// import Reminders from './reminders.svg';
import CRMLOGO from "../../Assets/iBizAccounts.png";
import { faStore } from "@fortawesome/free-solid-svg-icons/faStore";
import { faBarcode } from "@fortawesome/free-solid-svg-icons/faBarcode";
import { enableNotifications } from "../../utils/pushUtils";
import { showStaticExpenseNotification } from "../../utils/pushUtils";
// import { testBypassReady } from '../../utils/pushUtils';
// import Followup from './followup.svg';
// import ChallanSVG from './chalan.svg';
// import Projects from './../Pages/Projects/Projects';
// import { enableNotifications} from "../../utils/pushUtils";

const Base = ({ children }) => {
  const [MisUserDetails, SetUserDetails] = useState([]);

  // useEffect(() => {
  //   const MisUserDetailsSession = JSON.parse(
  //     sessionStorage.getItem("MisUserDetails")||localStorage.getItem("MisUserDetails")
  //   );
  //   SetUserDetails(MisUserDetailsSession);
  // }, []);
  const navigate = useNavigate();
  useEffect(() => {
    const MisUserDetailsSession = JSON.parse(
      sessionStorage.getItem("MisUserDetails") ||
        localStorage.getItem("MisUserDetails"),
    );

    if (MisUserDetailsSession) {
      SetUserDetails(MisUserDetailsSession);
    } else {
      navigate("/");
    }
  }, [navigate]);

  //   useEffect(() => {
  //   console.log("[DEBUG] Auto-running bypass test");
  //   testBypassReady();
  // }, []);

  useEffect(() => {
    // Small delay so UI feels loaded first (avoids feeling spammy)
    const timer = setTimeout(async () => {
      // You can check localStorage / IndexedDB / API if there's actually a new expense
      // For pure static test: always show (remove this in production!)
      await showStaticExpenseNotification({
        title: "New Estimate Added",
        body: "A new expense estimate has been uploaded and verified.  Tap to review delivery.",
      });
    }, 3000); // 3 seconds after mount

    return () => clearTimeout(timer); // cleanup
  }, [MisUserDetails]);

  const location = useLocation();

  const [reportIsOpen, setReportIsOpen] = useState(false);
  const [configIsOpen, setConfigIsOpen] = useState(false);
  const [projectsIsOpen, setProjectsIsOpen] = useState(false);
  const [salesIsOpen, setSalesIsOpen] = useState(false);
  const [isFullscreen, setIsFullscreen] = useState(false);

  const ReportsToggleDropdown = () => {
    setReportIsOpen(!reportIsOpen);
    setConfigIsOpen(false);
    setProjectsIsOpen(false);
    setSalesIsOpen(false);
  };

  const ConfigToggleDropdown = () => {
    setConfigIsOpen(!configIsOpen);
    setReportIsOpen(false);
    setProjectsIsOpen(false);
    setSalesIsOpen(false);
  };

  const ProjectsToggleDropdown = () => {
    setProjectsIsOpen(!projectsIsOpen);
    setReportIsOpen(false);
    setConfigIsOpen(false);
    setSalesIsOpen(false);
  };

  const SalesToggleDropdown = () => {
    setSalesIsOpen(!salesIsOpen);
    setReportIsOpen(false);
    setConfigIsOpen(false);
    setProjectsIsOpen(false);
  };

  const toggleFullscreen = (elem) => {
    elem = elem || document.documentElement;
    if (
      !document.fullscreenElement &&
      !document.mozFullScreenElement &&
      !document.webkitFullscreenElement &&
      !document.msFullscreenElement
    ) {
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.msRequestFullscreen) {
        elem.msRequestFullscreen();
      } else if (elem.mozRequestFullScreen) {
        elem.mozRequestFullScreen();
      } else if (elem.webkitRequestFullscreen) {
        elem.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      }
    }
  };

  useEffect(() => {
    const reportPaths = [
      "/leads-report",
      "/customers-report",
      "/reminders-report",
      "/followups-report",
    ];

    if (reportPaths.includes(location.pathname)) {
      setReportIsOpen(true);
    } else {
      setReportIsOpen(false);
    }
  }, [location.pathname]);

  // ------------------------------------------------------------
  // FIXED LOGOUT FUNCTION – clears storage + navigates
  // ------------------------------------------------------------
  const handleLogout = () => {
    console.log("Logging out...");
    // if (e) e.preventDefault();
    sessionStorage.removeItem("MisUserDetails");
    localStorage.removeItem("MisUserDetails");
    navigate("/", { replace: true });
  };
  const handleScan = (e) => {
    console.log("Navigating to scanner...");
    if (e) e.preventDefault();
    navigate("/scanner");
  };

  const useDropdownState = (paths, setState) => {
    const location = useLocation();

    useEffect(() => {
      if (paths.includes(location.pathname)) {
        setState(true);
      }
    }, [location.pathname, paths, setState]);
  };

  const reportPaths = [
    "/leads-report",
    "/customers-report",
    "/reminders-report",
    "/followups-report",
  ];

  useDropdownState(reportPaths, setReportIsOpen);

  const projectsPaths = [
    "/projects",
    "/project-locations",
    "/calander",
    "/delivery-chalan",
  ];

  useDropdownState(projectsPaths, setProjectsIsOpen);

  const configPaths = ["/customers", "/followups", "/logistic-rate"];

  useDropdownState(configPaths, setConfigIsOpen);

  const salesPaths = [
    "/products",
    "/credit-notes",
    "/payments",
    "/invoice",
    "/purchase-order",
  ];

  useDropdownState(salesPaths, setSalesIsOpen);

  return (
    <div className="main-wrapper">
      {/* Header */}
      <div className="header d-none d-md-block">
        <div className="header-left active px-1">
          <a className="logo logo-normal d-flex justify-content-start">
            <Link to="/dashboard">
              <img src={CRMLOGO} alt="crmlogo" />
            </Link>
          </a>
          <a className="logo logo-white">
            <Link to="/dashboard">
              <img src={CRMLOGO} alt="crmlogo" />
            </Link>
          </a>
          <a className="logo-small">
            <Link to="/dashboard">
              <img src={CRMLOGO} alt="crmlogo" />
            </Link>
          </a>
        </div>
        {/* <a
          className="mobile_btn"

        >
          <span className="bar-icon">
            <span style={{ backgroundColor: '#1B2850' }}></span>
            <span style={{ backgroundColor: '#1B2850' }}></span>
            <span style={{ backgroundColor: '#1B2850' }}></span>
          </span>
        </a> */}
        <ul className="nav user-menu">
          <li className="nav-item nav-searchinputs">
            <div className="top-nav-search">
              <a
                // href="javascript:void(0);"
                className="responsive-search"
              >
                <i className="fa fa-search"></i>
              </a>
              <form action="#" className="dropdown">
                <div className="searchinputs dropdown-toggle">
                  <input type="text" placeholder="Search" />
                  <div className="search-addon">
                    <span>
                      <i data-feather="x-circle" className="feather-14"></i>
                    </span>
                  </div>
                </div>
              </form>
            </div>
          </li>

          <li className="nav-item nav-item-box">
            <Link
              to="#"
              id="btnFullscreen"
              onClick={() => toggleFullscreen()}
              className={isFullscreen ? "Exit Fullscreen" : "Go Fullscreen"}
            >
              <FeatherIcon icon={`${isFullscreen ? "minimize" : "maximize"}`} />
            </Link>
          </li>
          {/* <li className="nav-item nav-item-box">
            <a>
              <FontAwesomeIcon icon={faEnvelope} />
              <span className="badge rounded-pill">1</span>
            </a>
          </li> */}

          <li className="nav-item nav-item-box">
            <a
              href="#"
              onClick={async (e) => {
                e.preventDefault();
                await enableNotifications();
              }}
              title="Enable Notifications"
            >
              <FontAwesomeIcon
                icon={faBell}
                style={{ color: "#1629bc", fontSize: "1.3rem" }}
              />
              {/* Later: add badge for unread count */}
              {/* <span className="badge rounded-pill bg-danger">3</span> */}
            </a>
          </li>
          <li className="nav-item dropdown nav-item-box">
            <a
              className="dropdown-toggle nav-link mobile_btn"
              data-bs-toggle="dropdown"
            >
              <FontAwesomeIcon icon={faBell} />
              {/* <span className="badge rounded-pill">2</span> */}
            </a>
            <div className="dropdown-menu notifications">
              <div className="topnav-dropdown-header">
                <span className="notification-title">Notifications</span>
                <a
                  // href="javascript:void(0)"
                  className="clear-noti"
                >
                  {" "}
                  Clear All{" "}
                </a>
              </div>
              <div className="noti-content d-none">
                <ul className="notification-list">
                  <li className="notification-message">
                    <a>
                      <div className="media d-flex">
                        <span className="avatar flex-shrink-0">
                          <img alt="" src="assets/img/profiles/avatar-02.jpg" />
                        </span>
                        <div className="media-body flex-grow-1">
                          <p className="noti-details d-none">
                            <span className="noti-title">
                              {MisUserDetails?.firstname +
                                " " +
                                MisUserDetails?.lastname}
                            </span>{" "}
                            added new task{" "}
                            <span className="noti-title">
                              Patient appointment booking
                            </span>
                          </p>
                          <p className="noti-time d-none">
                            <span className="notification-time">
                              4 mins ago
                            </span>
                          </p>
                        </div>
                      </div>
                    </a>
                  </li>
                </ul>
              </div>
              <div className="topnav-dropdown-footer">
                <a href="activities.html">View all Notifications</a>
              </div>
            </div>
          </li>

          <li className="nav-item nav-item-box">
            <a>
              <FontAwesomeIcon icon={faGear} />
            </a>
          </li>
          <li className="nav-item dropdown has-arrow main-drop">
            <a
              className="dropdown-toggle nav-link userset"
              data-bs-toggle="dropdown"
            >
              <span className="user-info">
                <span className="user-letter">
                  <img
                    src="assets/img/profiles/avator1.jpg"
                    alt=""
                    className="img-fluid"
                  />
                </span>
                <span className="user-detail">
                  <span className="user-name">{MisUserDetails?.Name}</span>
                  <span className="user-role">Super Admin</span>
                </span>
              </span>
            </a>
            <div className="dropdown-menu menu-drop-user">
              <div className="profilename">
                <div className="profileset">
                  <span className="user-img">
                    <img src="assets/img/profiles/avator1.jpg" alt="" />
                    <span className="status online"></span>
                  </span>
                  <div className="profilesets">
                    <h6>{MisUserDetails?.Name}</h6>
                    <h5>Super Admin</h5>
                  </div>
                </div>
                <hr className="m-0" />
                {/* <a className="dropdown-item">
                  {" "}
                  <i className="me-2" data-feather="user"></i> My Profile
                </a> */}
                {/* <Link to='/customers-report'> */}

                {/* <a className="dropdown-item">
                  <i className="me-2" data-feather="settings"></i>Settings
                </a> */}
                {/* </Link> */}
                <hr className="m-0" />
                <a className="dropdown-item logout pb-0" onClick={handleLogout}>
                  <img
                    src="assets/img/icons/log-out.svg"
                    className="me-2"
                    alt="img"
                  />
                  Logout
                </a>
              </div>
            </div>
          </li>
        </ul>
        <div
          className="mobile-menu-wrapper d-flex align-items-center"
          // style={{ marginLeft: "7px" }}
        >
          <div
            className="dropdown mobile-user-menu"
            style={{ marginLeft: "20px", marginRight: "20px" }}
          >
            {/* FIXED: Use <a> with onClick instead of <Link> */}
            <a className="nav-link" onClick={handleLogout}>
              <i
                className="fa-solid fa-right-from-bracket"
                style={{ color: "#1629bc" }}
              ></i>{" "}
            </a>

            {/* below notifications are hided */}
            {/* <a
              className="nav-link dropdown-toggle"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i className="fa fa-bell d-noe" style={{ color: "#1B2850" }}></i>
              <span className="badge rounded-pill">2</span>
            </a>
            <div className="dropdown-menu dropdown-menu-right notifications">
              <div className="topnav-dropdown-header">
                <span className="notification-title">Notifications</span>
                <a className="clear-noti">Clear All</a>
              </div>
              <div className="noti-content">
                <ul className="notification-list">
                  <li className="notification-message">
                    <a>
                      <div className="media d-flex">
                        <span className="avatar flex-shrink-0">
                          <img alt="" src="assets/img/profiles/avatar-02.jpg" />
                        </span>
                        <div className="media-body flex-grow-1">
                          <p className="noti-details">
                            <span className="noti-title">
                              {MisUserDetails?.firstname +
                                " " +
                                MisUserDetails?.lastname}
                            </span>{" "}
                            added new task{" "}
                            <span className="noti-title">
                              Patient appointment booking
                            </span>
                          </p>
                          <p className="noti-time">
                            <span className="notification-time">
                              4 mins ago
                            </span>
                          </p>
                        </div>
                      </div>
                    </a>
                  </li>
                </ul>
              </div>
              <div className="topnav-dropdown-footer">
                <a href="activities.html">View all Notifications</a>
              </div>
            </div> */}
          </div>

          {/* <div className="dropdown mobile-user-menu">
            <a
              className="nav-link  dropdown-toggle"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i
                className="fa fa-ellipsis-v d-none"
                style={{ color: "#1B2850" }}
              ></i>
            </a>
            <div className="dropdown-menu dropdown-menu-right">
              <a className="dropdown-item" onClick={handleLogout}>
                <i
                  className="fa-solid fa-right-from-bracket"
                  style={{ color: "red" }}
                ></i>{" "}
                &nbsp; &nbsp; Logouttab
              </a>
            </div>
          </div> */}
        </div>
      </div>
      <div className="header d-block d-md-none">
        <div className="d-flex">
          <div className="header-left active px-3">
            <a className="logo logo-normal d-flex justify-content-start">
              <Link to="/dashboard">
                <img src={CRMLOGO} alt="crmlogo" />
              </Link>
            </a>
            <a className="logo logo-white">
              <Link to="/dashboard">
                <img src={CRMLOGO} alt="crmlogo" />
              </Link>
            </a>
            <a className="logo-small">
              <Link to="/dashboard">
                <img src={CRMLOGO} alt="crmlogo" />
              </Link>
            </a>
          </div>
          <div
            className="d-flex align-items-center ms-auto me-3 mt-2"
            style={{ zIndex: 1000 }}
          >
            <div className="me-2 ">
              {MisUserDetails?.UnitBilling == true && (
                <Link to="/addProdctInventory" className="me-2">
                  <i
                    className="fa-solid fa-circle-plus fs-1"
                    style={{ color: "#1629bc" }}
                  ></i>
                </Link>
              )}
              {MisUserDetails?.OrgType === 22 && (
                <button
                  onClick={() => {
                    console.log("Navigating to scanner...");
                    navigate("/scanner");
                  }}
                  className="btn btn-link p-0 border-0 bg-transparent me-2"
                  style={{ cursor: "pointer" }}
                  title="Scan"
                >
                  <i
                    className="bi bi-upc-scan fs-1"
                    style={{ color: "#1629bc" }}
                  ></i>
                </button>
              )}
              <button
                onClick={() => navigate("/Estimate-List")}
                className="btn btn-link p-0 border-0 bg-transparent me-2"
              >
                <i
                  className="fa-solid fa-list fs-1"
                  style={{ color: "#1629bc" }}
                ></i>
              </button>
            </div>
            <div className="me-2 ">
              <a
                href="#"
                onClick={async (e) => {
                  e.preventDefault();
                  await enableNotifications();
                }}
                title="Enable Notifications"
              >
                <FontAwesomeIcon
                  icon={faBell}
                  style={{ color: "#1629bc", fontSize: "1.3rem" }}
                />
                {/* Later: add badge for unread count */}
                {/* <span className="badge rounded-pill bg-danger">3</span> */}
              </a>

              {/* <i
                className="fa-solid fa-bell d-none fs-1"
                style={{ color: "#1629bc" }}
              ></i> */}
            </div>

            <div className="">
              <a
                onClick={handleLogout}
                style={{ cursor: "pointer", textDecoration: "none" }}
              >
                <i
                  className="fa-solid fa-right-from-bracket fs-1"
                  style={{ color: "#1629bc" }}
                ></i>
              </a>
            </div>
          </div>
        </div>

        {/* <div
          className="mobile-menu-wrapper d-flex align-items-center"
          style={{ marginLeft: "7px" }}
        >
          <div className="dropdown mobile-user-menu">
            <a
              className="nav-link dropdown-toggle"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i
                className="fa fa-ellipsis-v d-none"
                style={{ color: "#1B2850" }}
              ></i>
            </a>
            <div className="dropdown-menu dropdown-menu-right">
              <a className="dropdown-item" onClick={handleLogout}>
                <i
                  className="fa-solid fa-right-from-bracket"
                  style={{ color: "red" }}
                ></i>{" "}
                &nbsp; &nbsp; Logout
              </a>
            </div>
          </div>
        </div> */}
      </div>
      {/* Sidebar */}
      <div className="sidebar d-none d-md-block d-lg-block" id="sidebar">
        <div
          className="sidebar-inner slimscroll"
          style={{ height: "90vh", overflowY: "auto" }}
        >
          <div id="sidebar-menu" className="sidebar-menu">
            <ul>
              <li className="submenu-open">
                <ul>
                  <li>
                    <Link
                      to="/dashboard"
                      className={
                        location.pathname === "/dashboard" ? "text-primary" : ""
                      }
                    >
                      <FontAwesomeIcon
                        icon={faHome}
                        className="me-2 text-primary"
                      />
                      Dashboard
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/products"
                      className={
                        location.pathname === "/product" ? "text-primary" : ""
                      }
                    >
                      <FontAwesomeIcon
                        icon={faBlenderPhone}
                        className="me-2 text-primary"
                      />
                      products
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/stores"
                      className={
                        location.pathname === "/sales" ? "text-primary" : ""
                      }
                    >
                      <FontAwesomeIcon
                        icon={faStore}
                        className="me
                        -2 text-primary"
                      />
                      Stores
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/orders"
                      className={
                        location.pathname === "/sales" ? "text-primary" : ""
                      }
                    >
                      <FontAwesomeIcon
                        icon={faCartShopping}
                        className="me
                        -2 text-primary"
                      />
                      Orders
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/recentstock"
                      className={
                        location.pathname === "/sales" ? "text-primary" : ""
                      }
                    >
                      <FontAwesomeIcon
                        icon={faChartLine}
                        className="me
                        -2 text-primary"
                      />
                      Recent Stock
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/suppliers"
                      className={
                        location.pathname === "/sales" ? "text-primary" : ""
                      }
                    >
                      <FontAwesomeIcon
                        icon={faPersonBiking}
                        className="me
                        -2 text-primary"
                      />
                      Suppliers
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/pendingindent"
                      className={
                        location.pathname === "/pendingindent"
                          ? "text-primary"
                          : ""
                      }
                    >
                      <FontAwesomeIcon
                        icon={faIndent}
                        className="me
                        -2 text-primary"
                      />
                      Recent Indent
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/mostorder"
                      className={
                        location.pathname === "/mostorder" ? "text-primary" : ""
                      }
                    >
                      <FontAwesomeIcon
                        icon={faShoppingCart}
                        className="me
                        -2 text-primary"
                      />
                      Most Ordered
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/brands"
                      className={
                        location.pathname === "/brands" ? "text-primary" : ""
                      }
                    >
                      <FontAwesomeIcon
                        icon={faBarcode}
                        className="me
                        -2 text-primary"
                      />
                      Brands
                    </Link>
                  </li>

                  {/* <li className="mb-2 fw-semibold">
                    <Link
                      to="/tasks"
                      className={
                        location.pathname === "/tasks" ? "text-primary" : ""
                      }
                    >
                      <FontAwesomeIcon
                        icon={faListCheck}
                        className="me-2 text-primary"
                      />
                      Tasks
                    </Link>
                  </li> */}
                  {/* <li className="mb-2 fw-semibold">
                    <Link
                      to="/credit-notes"
                      className={
                        location.pathname === "/credit-notes"
                          ? "text-primary"
                          : ""
                      }
                    >
                      <FontAwesomeIcon
                        icon={faMoneyBill}
                        className="me-2 text-primary"
                      />
                      Credit Notes
                    </Link>
                  </li> */}
                  {/* <li>
                    <div className="dropdown">
                      <p
                        className="d-flex"
                        style={{ cursor: "pointer" }}
                        onClick={ReportsToggleDropdown}
                      >
                        <a>
                          <span>
                            <FontAwesomeIcon
                              icon={faFile}
                              className="me-2 text-primary"
                            />
                            Reports
                            <i
                              className={`fa-solid fa-chevron-${reportIsOpen ? "up" : "down"
                                }  fs-6`}
                              style={{ marginLeft: "6rem" }}
                            ></i>
                          </span>
                        </a>
                      </p>
                      {reportIsOpen && (
                        <div
                          className="dropdown-content"
                          style={{ marginTop: "-20px" }}
                        >
                          <ul className="ms-3">
                            <li>
                              <Link
                                to="/leads-report"
                                className={
                                  location.pathname === "/leads-report"
                                    ? "text-primary"
                                    : ""
                                }
                              >
                                <FontAwesomeIcon
                                  icon={faArrowRight}
                                  className="me-2"
                                />
                                Leads
                              </Link>
                            </li>
                            <li>
                              <Link
                                to="/customers-report"
                                className={
                                  location.pathname === "/customers-report"
                                    ? "text-primary"
                                    : ""
                                }
                              >
                                <FontAwesomeIcon
                                  icon={faArrowRight}
                                  className="me-2"
                                />
                                Customers
                              </Link>
                            </li>
                            <li>
                              <Link
                                to="/reminders-report"
                                className={
                                  location.pathname === "/reminders-report"
                                    ? "text-primary"
                                    : ""
                                }
                              >
                                <FontAwesomeIcon
                                  icon={faArrowRight}
                                  className="me-2"
                                />
                                Reminders
                              </Link>
                            </li>
                            <li>
                              <Link
                                to="/followups-report"
                                className={
                                  location.pathname === "/followups-report"
                                    ? "text-primary"
                                    : ""
                                }
                              >
                                <FontAwesomeIcon
                                  icon={faArrowRight}
                                  className="me-2"
                                />
                                Followups
                              </Link>
                            </li>
                          </ul>
                        </div>
                      )}
                    </div>
                  </li> */}
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Page Content */}
      <div className="page-wrapper">
        <div className="content">{children}</div>
      </div>
    </div>
  );
};

export default Base;
